// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import Inicio from './components/inicio/inicio';
import Empresa from './components/empresa/empresa';
import Servicio from './components/servicio/servicio';
import RF from './components/rf/rf';
import MRO from './components/mro/mro';
import Promociones from './components/promociones/promociones';
import Tienda from './components/tienda/tienda';
import Contacto from './components/contacto/contacto';
import CrearProducto from './components/Administradores/CrearProducto.js';
import Header from './components/Header/Header'; // Header de clientes
import AdminHeader from './components/Header/AdminHeader'; // Header de administradores
import Cotizaciones from './components/Administradores/Cotizaciones.js';
import CrearCotizacion from './components/Cotizacion/CrearCotizacion.js';
import AdminTienda from './components/Administradores/AdminTienda.js';
import Administradores from './components/Administradores/Administradores.js';
import Footer from './components/Footer/Footer.js'; // Importa el Footer
import Login from './components/Administradores/Login/Login.js';
import ProtectedRoute from './components/Administradores/ProtectedRoute'; // Importa el nuevo componente

function App() {
  const cartCount = 0; // Ejemplo, este número puede cambiar dinámicamente

  return (
    <Router>
      <div className="App">
        <Headers /> {/* Usamos un componente para determinar cuál header mostrar */}
        <main>
          <Routes>
            <Route path="/" element={<Navigate to="/inicio" replace />} /> {/* Redirige a /inicio */}
            <Route path="/inicio" element={<Inicio />} />
            <Route path="/empresa" element={<Empresa />} />
            <Route path="/servicio" element={<Servicio />} />
            <Route path="/rf" element={<RF />} />
            <Route path="/mro" element={<MRO />} />
            <Route path="/promociones" element={<Promociones />} />
            <Route path="/tienda" element={<Tienda />} />
            <Route path="/contacto" element={<Contacto />} />

            {/* Rutas protegidas */}
            <Route path="/crear-producto" element={<ProtectedRoute><CrearProducto /></ProtectedRoute>} />
            <Route path="/cotizaciones" element={<ProtectedRoute><Cotizaciones /></ProtectedRoute>} />
            <Route path="/admin-tienda" element={<ProtectedRoute><AdminTienda /></ProtectedRoute>} />
            <Route path="/administradores" element={<ProtectedRoute><Administradores /></ProtectedRoute>} />
            <Route path="/crear-cotizacion" element={<CrearCotizacion />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </main>
        <Footer /> {/* Añade el Footer aquí */}
      </div>
    </Router>
  );
}

// Componente que decide qué encabezado mostrar
const Headers = () => {
  const location = useLocation();

  // Definimos las rutas que requieren el Header de Administrador
  const adminRoutes = ['/crear-producto/', '/cotizaciones/', '/admin-tienda/', '/administradores/', '/crear-producto', '/cotizaciones', '/admin-tienda', '/administradores'];

  // Determinamos si la ruta actual es una ruta de administrador
  const isAdminRoute = adminRoutes.includes(location.pathname);

  return isAdminRoute ? <AdminHeader /> : <Header cartCount={0} />;
};

export default App;
